import React from 'react'
import './footer-text.css'

export const FooterText = ({ text }) => {
    return <div className="footer-text">{text}</div>
}
